<template>
  <div class="n-slider">
    <n-progress-bar class="progress-bar" :percentage="value" />
    <input
      type="range"
      min="0"
      max="100"
      :value="value"
      @input="$emit('change', Number.parseInt($event.target.value))"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import NProgressBar from '@/modules/global/components/core/NProgressBar.vue'

@Component({
  components: { NProgressBar },
  model: {
    prop: 'value',
    event: 'change'
  }
})
export default class NSlider extends Vue {
  @Prop({ required: true, type: Number }) value!: number
}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

$diameter: $notch-space-8x;

.n-slider {
  position: relative;

  display: flex;
  align-items: center;

  height: $diameter;

  .progress-bar {
    width: 100%;
  }
}

input[type='range'] {
  position: absolute;
  right: 0;
  left: 0;

  width: 100%;
  height: $notch-space-2x;
  background-color: transparent;

  cursor: pointer;

  -webkit-appearance: none;
  appearance: none;

  // for some reason, writing a rule for "&::-webkit-slider-thumb, &::-moz-range-thumb { ... }" does not work
  // but writing the same thing with single selectors does the trick, hence this mixin
  @mixin slider-thumb {
    appearance: none;

    width: $diameter;
    height: $diameter;

    background-color: white;

    border: 1px solid $notch-color-neutral-sand-200;
    border-radius: $notch-radius-full;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    @include slider-thumb;
  }

  &::-moz-range-thumb {
    @include slider-thumb;
  }
}
</style>
